<template>
  <div class="foot">
    <div class="top">
      <div class="column">
        <div class="content">Enlace Rápido</div>
        <a href="/Sobre">
          <div>Sobre nosotros</div>
        </a>
        <a href="/Ayuda">
          <div>Preguntas frecuentes</div>
        </a>
        <div
          style="font-size: 24px;
                 font-family: ArialMT;
                 color: #FFFFFF;
                 margin-top: 34px;
                 text-decoration: none;
                "
        >
          Síguenos en:
          <a
            href="https://www.facebook.com/profile.php?id=100089693517828"
            target="_blank"
          >
            <img
              style="vertical-align: middle;margin: 0 20px;"
              src="../assets/image/newImage/facebookIcon.png"
              alt=""
            />
          </a>
          <a href="https://www.instagram.com/credisol.pe" target="_blank">
            <img
              style="vertical-align: middle; width:35px;"
              src="../assets/image/newImage/insIcon.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="column">
        <div class="content">Sobre CrediSol</div>
        <a href="/Aviso">
          <div>Aviso Privacidad</div>
        </a>
        <a target="blank" href="https://www.credisol.pe/h5/use.html">
          <div>Términos y Condiciones</div>
        </a>
      </div>
      <div class="column no_underline">
        <div class="content">Contactos</div>
        <div>
          <img src="../assets/image/newImage/email.png" alt="" />
          servicio@credisol.pe
        </div>
        <div>
          <img src="../assets/image/newImage/whatsapp.png" alt="" />
          +51
          <!-- +51 924267231 -->
          {{ whatsApp }}
        </div>
        <div>
          <img src="../assets/image/newImage/phone.png" alt="" />
          <!-- +51 17309229 -->
          +51 {{ phone }}
        </div>
        <div style="display: flex">
          <img
            style="margin-right: 10px"
            src="../assets/image/newImage/data.png"
            alt=""
          />
          <span>
            <!-- LUN-VIER 9:00 A 18:40 <br />
            SAB 9:00 A 14:40 -->
            {{ daySection[0] }}<br />{{ daySection[1] || "" }}
          </span>
        </div>
      </div>
      <div class="column columnImgLast">
        <div class="content">Descargar</div>
        <a
          class="downLoadBox"
          href="https://www.credisol.pe/credisol.apk"
        >
          <!-- <i class="el-icon-download"></i>
            <p>Haga clic para descargar</p> -->
          <img src="@/assets/image/Inicio/two.png" alt="" />
        </a>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 37px;
            text-decoration: none;
          "
        >
          <img
            style="width: 38px; height: 32px; display: inline"
            src="../assets/image/newImage/libro-abierto.png"
            alt=""
          />
          <span style="text-decoration: none;color:#fff">
            Libro de <br />
            Reclamaciones
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footPage",
  data() {
    return {
      whatsApp: "",
      phone: "",
      daySection: [],
    };
  },
  mounted() {
    const data = JSON.parse(localStorage.getItem("customerData"));
    this.whatsApp = data.customerServiceWhatsApp.whatsApp;
    this.phone = data.customerServicePhone.phone;
    this.daySection = data.customerServiceWorkTimeInfo.daySection.split(",");
  },
};
</script>

<style lang="scss" scoped>
.foot {
  background: #048f4c linear-gradient(315deg, #f98043 0%, #c90000 100%);
  .top {
    display: flex;
    justify-content: center;
    padding-top: 66px;
    box-sizing: border-box;
    height: 325px;

    .column {
      display: flex;
      flex-direction: column;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;
      margin-right: 100px;

      .content {
        font-size: 24px;
        color: #ffffff;
        margin-top: 0 !important;
        margin-bottom: 30px;
        text-decoration: none;
      }

      div {
        font-size: 18px;
        color: #ffc029;
        text-decoration: underline;
        margin-bottom: 10px;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    .no_underline {
      div {
        text-decoration: none;
      }
      img {
        width: 32px;
        height: 32px;
        display: inline;
        vertical-align: middle;
      }
    }

    .columnImgLast img {
      width: 193px;
      height: 62px;
    }
  }
  .bottom {
    color: #fff;
    text-align: center;
    padding-bottom: 30px;
  }
}
.downLoadBox {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 15px;
  i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30%;
    color: #c90000;
    text-align: center;
    font-size: 30px;
    background-color: #ccc;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  p {
    width: 70%;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #333;
  }
}
</style>
